import { useEffect, useRef } from "react";
import { gsap } from "../animations/gsap";

const fromStates = [
  { y: 60 },
  { x: -80 },
  { scale: 0.88 },
  { x: 80 },
  { y: 50, rotationX: 12 },
];

const toStates = [
  { y: 0, duration: 0.9, ease: "power3.out" },
  { x: 0, duration: 0.9, ease: "power3.out" },
  { scale: 1, duration: 0.8, ease: "back.out(1.4)" },
  { x: 0, duration: 0.9, ease: "power3.out" },
  { y: 0, rotationX: 0, duration: 1, ease: "power4.out" },
];

let counter = 0;

export default function Reveal({ children, className = "", triggerAt = 0, delay = 0 }) {
  const ref = useRef(null);
  const idx = useRef(counter++ % fromStates.length);

  useEffect(() => {
    const el = ref.current;
    const i = idx.current;
    if (!el) return;

    gsap.set(el, { ...fromStates[i], opacity: 0 });

    let animated = false;

    const check = () => {
      const y = window.scrollY;

      if (y >= triggerAt && !animated) {
        // Entró al rango → animar hacia adentro
        animated = true;
        gsap.to(el, { ...toStates[i], opacity: 1, delay });
      } else if (y < triggerAt && animated) {
        // Volvió a subir → resetear para replay
        animated = false;
        gsap.killTweensOf(el);
        gsap.set(el, { ...fromStates[i], opacity: 0 });
      }
    };

    window.addEventListener("scroll", check, { passive: true });
    check(); // revisar posición inicial

    return () => window.removeEventListener("scroll", check);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={ref} className={className} data-reveal={idx.current}>
      {children}
    </div>
  );
}
